import React from 'react';
import { useLatestCoverage } from '../../hooks/fotbollplay';
import VideoCard from './VideoCard';

function LatestConverage() {
  const [videos, loading, error] = useLatestCoverage(3);

  return (
    <div className="video__container">
      {videos.map((video) => (
        <VideoCard video={video} />
      ))}
    </div>
  );
}

export default LatestConverage;
